import { useGetStudentAnswers } from '../present/activity-answers.hooks';
import { useWsClientStatus } from 'lib/ws/ws-apollo';

export const useGetStudentAnswersPollingFallback = ({
  componentId,
  userClassId,
  studentId,
}: {
  componentId: string;
  userClassId: number | null;
  studentId?: number;
}) => {
  const { isConnectionActive } = useWsClientStatus();

  const { data, error } = useGetStudentAnswers({
    fetchPolicy: 'cache-and-network',
    pollInterval: isConnectionActive ? 0 : 5000,
    classId: userClassId,
    componentId,
    studentId,
  });

  return {
    data,
    error,
  };
};
